module.exports = __webpack_public_path__ + "img/at&t.537cafe5.svg";